import React, { useState, useEffect } from "react"; 
import { useParams, useNavigate } from "react-router-dom";
import "./festival.css";
import prevIcon from "../../assets/prew1.webp";
import nextIcon from "../../assets/next1.webp";
import Footer from "../footer/footer";
import Header from "../header/header";
import FestivalCard from "./FestivalCard";

// Import the festival data with content
import { festivalData } from "./festivalData";

const Festivals = () => {
  const { month } = useParams();
  const navigate = useNavigate();

  const monthsShort = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];

  const monthsFull = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];

  const [selectedMonthIndex, setSelectedMonthIndex] = useState(0);

  useEffect(() => {
    if (month) {
      const index = monthsFull.findIndex((m) => m.toLowerCase() === month.toLowerCase());
      if (index !== -1) {
        setSelectedMonthIndex(index);
      } else {
        setSelectedMonthIndex(0);
      }
    } else {
      setSelectedMonthIndex(0);
    }
  }, [month]);

  const handlePrevMonth = () => {
    const newIndex = (selectedMonthIndex - 1 + monthsShort.length) % monthsShort.length;
    navigate(`/festival/${monthsFull[newIndex].toLowerCase()}`);
  };

  const handleNextMonth = () => {
    const newIndex = (selectedMonthIndex + 1) % monthsShort.length;
    navigate(`/festival/${monthsFull[newIndex].toLowerCase()}`);
  };

  const selectedMonthFull = monthsFull[selectedMonthIndex];
  const monthKey = selectedMonthFull.toLowerCase();
  const festivalsForMonth = festivalData[monthKey] || [];

  const metaTags = {
    january: {
      title: "AstroBhagya – January Month Festival Calendar 2026",
      description: "Check out the January 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for January 2026 in India",
      keywords: "January Month Festival Calendar 2026, Hindu tithi calendar January, January festival 2026",
    },
    february: {
      title: "AstroBhagya – February Month Festival Calendar 2026",
      description: "Check out the February 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for February 2026 in India",
      keywords: "February Month Festival Calendar 2026, Hindu tithi calendar February, February festival 2026",
    },
    march: {
      title: "AstroBhagya – March Month Festival Calendar 2026",
      description: "Check out the March 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for March 2026 in India",
      keywords: "March Month Festival Calendar 2026, Hindu tithi calendar March, March festival 2026",
    },
    april: {
      title: "AstroBhagya – April Month Festival Calendar 2026",
      description: "Check out the April 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for April 2026 in India",
      keywords: "April Month Festival Calendar 2026, Hindu tithi calendar April, April festival 2026",
    },
    may: {
      title: "AstroBhagya – May Month Festival Calendar 2026",
      description: "Check out the May 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for May 2026 in India",
      keywords: "May Month Festival Calendar 2026, Hindu tithi calendar May, May festival 2026",
    },
    june: {
      title: "AstroBhagya – June Month Festival Calendar 2026",
      description: "Check out the June 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for June 2026 in India",
      keywords: "June Month Festival Calendar 2026, Hindu tithi calendar June, June festival 2026",
    },
    july: {
      title: "AstroBhagya – July Month Festival Calendar 2026",
      description: "Check out the July 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for July 2026 in India",
      keywords: "July Month Festival Calendar 2026, Hindu tithi calendar July, July festival 2026",
    },
    august: {
      title: "AstroBhagya – August Month Festival Calendar 2026",
      description: "Check out the August 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for August 2026 in India",
      keywords: "August Month Festival Calendar 2026, Hindu tithi calendar August, August festival 2026",
    },
    september: {
      title: "AstroBhagya – September Month Festival Calendar 2026",
      description: "Check out the September 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for September 2026 in India",
      keywords: "September Month Festival Calendar 2026, Hindu tithi calendar September, September festival 2026",
    },
    october: {
      title: "AstroBhagya – October Month Festival Calendar 2026",
      description: "Check out the October 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for October 2026 in India",
      keywords: "October Month Festival Calendar 2026, Hindu tithi calendar October, October festival 2026",
    },
    november: {
      title: "AstroBhagya – November Month Festival Calendar 2026",
      description: "Check out the November 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for November 2026 in India",
      keywords: "November Month Festival Calendar 2026, Hindu tithi calendar November, November festival 2026",
    },
    december: {
      title: "AstroBhagya – December Month Festival Calendar 2026",
      description: "Check out the December 2026 festival calendar and Hindu tithi calendar. Find detailed festival dates, fasting days, and auspicious events for December 2026 in India",
      keywords: "December Month Festival Calendar 2026, Hindu tithi calendar December, December festival 2026",
    },
  };

  useEffect(() => {
    const monthLower = selectedMonthFull.toLowerCase();
    if (metaTags[monthLower]) {
      const meta = metaTags[monthLower];
      
      document.title = meta.title;
      
      const metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute("content", meta.description);
      } else {
        const newMetaDescription = document.createElement('meta');
        newMetaDescription.setAttribute("name", "description");
        newMetaDescription.setAttribute("content", meta.description);
        document.head.appendChild(newMetaDescription);
      }
      
      const metaKeywords = document.querySelector('meta[name="keywords"]');
      if (metaKeywords) {
        metaKeywords.setAttribute("content", meta.keywords);
      } else {
        const newMetaKeywords = document.createElement('meta');
        newMetaKeywords.setAttribute("name", "keywords");
        newMetaKeywords.setAttribute("content", meta.keywords);
        document.head.appendChild(newMetaKeywords);
      }
      
      const authorMeta = document.querySelector('meta[name="author"]');
      if (!authorMeta) {
        const newAuthorMeta = document.createElement('meta');
        newAuthorMeta.setAttribute("name", "author");
        newAuthorMeta.setAttribute("content", "Heavenly Expectation Private Limited");
        document.head.appendChild(newAuthorMeta);
      }
      
      const revisitMeta = document.querySelector('meta[name="revisit-after"]');
      if (!revisitMeta) {
        const newRevisitMeta = document.createElement('meta');
        newRevisitMeta.setAttribute("name", "revisit-after");
        newRevisitMeta.setAttribute("content", "7 days");
        document.head.appendChild(newRevisitMeta);
      }
      
      const distributionMeta = document.querySelector('meta[name="distribution"]');
      if (!distributionMeta) {
        const newDistributionMeta = document.createElement('meta');
        newDistributionMeta.setAttribute("name", "distribution");
        newDistributionMeta.setAttribute("content", "global");
        document.head.appendChild(newDistributionMeta);
      }
      
      const ratingMeta = document.querySelector('meta[name="rating"]');
      if (!ratingMeta) {
        const newRatingMeta = document.createElement('meta');
        newRatingMeta.setAttribute("name", "rating");
        newRatingMeta.setAttribute("content", "general");
        document.head.appendChild(newRatingMeta);
      }
    }
  }, [selectedMonthFull]);

  return (
    <div>
      <Header />
      <div className="container-fluid">
        <h2 className="title">Festivals 2026</h2>
        <div className="container-festival">
          <div className="selected-month-container">
            <button className="nav-btn left" onClick={handlePrevMonth} aria-label="Previous Month">
              <img src={prevIcon} alt="Previous Month" />
            </button>
            <h3 className="selected-month">{selectedMonthFull.toUpperCase()}</h3>
            <button className="nav-btn right" onClick={handleNextMonth} aria-label="Next Month">
              <img src={nextIcon} alt="Next Month" />
            </button>
          </div>

          <div className="month-nav">
            <div className="months">
              {monthsShort.map((monthShort, index) => (
                <span
                  key={monthShort}
                  className={`month ${selectedMonthIndex === index ? "active" : ""}`}
                  onClick={() => navigate(`/festival/${monthsFull[index].toLowerCase()}`)}
                >
                  {monthShort}
                </span>
              ))}
            </div>
          </div>

          <div className="festival-grid">
            {festivalsForMonth.map((festival, index) => (
              <FestivalCard
                key={index}
                image={festival.image}
                title={festival.title}
                date={festival.date}
                tithi={festival.tithi}
                paksha={festival.paksha}
                alt={festival.title || `${selectedMonthFull} Festival ${index + 1}`}
              />
            ))}
          </div>
        </div>

        <div className="festival-container">
          <div className="festival-content">
            <h2>Upcoming Hindu and Indian Festivals in 2026</h2>
            <p>Discover the Important Festivals and Significant Days Celebrated Across India and Beyond</p>
            <p>Festivals are a time for joy, celebration, and spiritual connection, bringing people together in communities to celebrate shared traditions.</p>
            <p>Throughout the year, festivals provide a perfect blend of prayers, rituals, music, dance, and feasts—marking moments of renewal and togetherness.</p>
            <p>Here's a list of the key Hindu and Indian festivals in 2026. People across India and the world celebrate these festivals with immense enthusiasm, decorating homes, exchanging goodwill, and embracing cultural rituals. From January to December, there is no shortage of vibrant occasions to honour and cherish.</p>
            <p>At AstroBhagya, we provide a comprehensive listing of significant festivals celebrated across India and around the world. Our month-by-month guide includes dates, timings, and relevant details for all the major festivals, including auspicious fasting days and key observances.</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Festivals;